import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'error',
  props: {
    error: {
      default: null
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t,
      locale = _useI18n.locale;
    var localePath = useLocalePath();
    var pageNotFound = '404 Not Found';
    var otherError = t('errors.generic');
    useNuxt2Meta(function () {
      var _props$error;
      return {
        title: ((_props$error = props.error) === null || _props$error === void 0 ? void 0 : _props$error.statusCode) === 404 ? pageNotFound : otherError,
        htmlAttrs: {
          lang: locale.value
        }
      };
    });
    return {
      __sfc: true,
      props: props,
      t: t,
      locale: locale,
      localePath: localePath,
      pageNotFound: pageNotFound,
      otherError: otherError
    };
  }
});